import { useMemo } from "react";
import { JsonHttpClient, TokenHandlingHttpClient } from "@ftdr/http-utils";
import { CscPaymentsJSClient } from "@ftdr/cscpayments-js-client";

type UseHandleClient = {
  cscPaymentsJsClient: CscPaymentsJSClient;
};

export const useHandleCscClient = (
  baseURL: string,
  token: string
): UseHandleClient => {
  const cscPaymentsJsClient = useMemo(() => {
    const tokenHttpClient = new TokenHandlingHttpClient(token);
    return new CscPaymentsJSClient(
      baseURL,
      new JsonHttpClient(tokenHttpClient)
    );
  }, [baseURL, token]);

  return { cscPaymentsJsClient };
};
